import axios, { AxiosInstance } from 'axios'
import { IAPIAdapter, IEstablishmentMenu } from '../../interfaces'
import APIHelper from '../../helpers/api'
import { IAppInitResponse } from './types'
import endpoints from './endpoints'

export default class MobileAPIAdapter implements IAPIAdapter {
  client: AxiosInstance
  isAuthenticated: Boolean

  constructor() {
    this.client = axios.create()
    this.isAuthenticated = false
  }

  private async performRequest<T>(endpoint: string, insecure: boolean = false): Promise<T> {
    if (!this.isAuthenticated && !insecure) await this.getToken()
    return this.client.get(endpoint).then((data: any) => APIHelper.extractData<T>(data))
  }

  private async getToken(): Promise<string> {
    const token = await this.performRequest<IAppInitResponse>(endpoints.appInit(), true).then(
      APIHelper.extractToken
    )

    this.client.defaults.headers['authorization'] = token
    this.isAuthenticated = true

    return token
  }

  async getEstablishmentMenu(id: number): Promise<IEstablishmentMenu> {
    return this.performRequest<IEstablishmentMenu>(endpoints.getEstablishmentMenu({ id }))
  }
}
